import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
} from "@mui/material";
import { REQUIREMENT } from "helpers/constants";
import { FC, useMemo, useState } from "react";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Requirement } from "types/requirement";
import { DomainColorSquares } from "components/Requirements";

type OrganizationRequirementsProps = {
  requirements: Requirement[];
};

export const OrganizationRequirements: FC<OrganizationRequirementsProps> = ({
  requirements,
}) => {
  const [showEpas, setShowEpas] = useState(true);
  const [showCompetencies, setShowCompetencies] = useState(true);

  const requirements_epa = useMemo(() => {
    return requirements.filter(
      (req) => req.type === REQUIREMENT.REQUIREMENT_EPA,
    );
  }, [requirements]);

  const requirements_competency = useMemo(() => {
    return requirements.filter(
      (req) => req.type === REQUIREMENT.REQUIREMENT_COMPETENCY,
    );
  }, [requirements]);

  if (requirements_epa.length === 0 && requirements_competency.length === 0) {
    return null;
  }

  return (
    <Box>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" fontWeight={400} sx={{ mb: 2 }}>
        Requirements
      </Typography>
      {requirements_epa.length > 0 && (
        <Box my={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            mb={1}
          >
            <Typography variant="body1" fontWeight={600}>
              EPAS
            </Typography>
            <Button
              variant={"outlined"}
              color="primary"
              size="small"
              onClick={() => setShowEpas(!showEpas)}
              startIcon={showEpas ? <ExpandLess /> : <ExpandMore />}
            >
              {showEpas ? "Hide EPAS" : "Display EPAS"}
            </Button>
          </Box>
          {showEpas && (
            <Box my={2}>
              <List>
                {requirements_epa?.map((requirement, index) => (
                  <ListItem
                    key={requirement.requirement_id}
                    sx={{
                      borderBottom:
                        index === requirements_epa.length - 1
                          ? "none"
                          : "1px solid #E0E0E0",
                    }}
                  >
                    <ListItemText
                      primary={requirement.name}
                      secondary={
                        <DomainColorSquares requirement={requirement} />
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </Box>
      )}

      {requirements_competency.length > 0 && (
        <Box my={2}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            mb={1}
          >
            <Typography variant="body1" fontWeight={600}>
              Competencies
            </Typography>
            <Button
              variant={"outlined"}
              color="primary"
              size="small"
              onClick={() => setShowCompetencies(!showCompetencies)}
              startIcon={showCompetencies ? <ExpandLess /> : <ExpandMore />}
            >
              {showCompetencies ? "Hide Competencies" : "Display Competencies"}
            </Button>
          </Box>
          {showCompetencies && (
            <List>
              {requirements_competency?.map((requirement, index) => (
                <ListItem
                  key={requirement.requirement_id}
                  sx={{
                    borderBottom:
                      index === requirements_competency.length - 1
                        ? "none"
                        : "1px solid #E0E0E0",
                  }}
                >
                  <ListItemText
                    primary={requirement.name}
                    secondary={
                      <DomainColorSquares requirement={requirement} />
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      )}
    </Box>
  );
};
